import { Kid } from 'models/Kid';
import moment, { Moment } from 'moment';
import {
    IPayFormFields,
    JobPaymentTypes,
    PaymentSchedule,
    ProviderSelection,
    RequestType,
    StartEstimateMonthType,
} from './JobRequestTypes';

const dayField = {
    selected: false,
    start: null as Moment | null,
    end: null as Moment | null,
    slots: 1,
};

const ongoingFormFields = {
    startDate: moment() as Moment | null,
    endDate: moment().add(28, 'days') as Moment | null,
    startEstimateMonth: null as StartEstimateMonthType,
    daysOfTheWeek: {
        Monday: dayField,
        Tuesday: dayField,
        Wednesday: dayField,
        Thursday: dayField,
        Friday: dayField,
        Saturday: dayField,
        Sunday: dayField,
    },
    sameTimes: true,
    longTermJob: true,
    multipleProviders: false,
    paymentSchedule: undefined as PaymentSchedule | undefined,
};

const oneTimeFormFields = {
    jobTimes: {
        start: null as Moment | null,
        end: null as Moment | null,
        slots: 1,
    },
    jobDate: moment() as Moment | null,
    isQuickFill: false as boolean | null,
};

const commonFormFields = (isBusiness: boolean) => {
    const payMin = isBusiness ? 13 : 19;
    const payMax = isBusiness ? 15 : 24;

    return {
        comments: '',
        headline: '',
        requestType: '' as RequestType,
        pay: {
            payMin,
            payMax,
            payFixed: null,
            isFixedPay: null,
        } as IPayFormFields,
        transportation: false as boolean | null,
        pastProviders: [] as ProviderSelection[],
        preferredProviders: [] as ProviderSelection[],
        providerType: { sitter: true, tutor: false, teacher: false, nanny: false },
        kids: [] as Kid[],
        jobTypeId: 1,
        otherJobType: '',
        userEmail: '',
        zipCode: '',
        acceptedTandemPayAgreement: undefined as boolean | undefined,
        code: '',
        businessJobType: undefined,
        payType: isBusiness ? ('PERCENTAGE' as JobPaymentTypes) : null,
        jobQualifications: [],
        address: undefined,
        jobDetails: [],
        payScales: [...Array.from({ length: payMax - payMin + 1 })].map((x, i) => {
            return { rate: i + payMin, description: '' };
        }),
        breakRequired: false,
        breakLength: undefined,
        slotsAvailable: 1,
    };
};

export const initialForm = (isBusiness: boolean) => ({
    ...commonFormFields(isBusiness),
    ...oneTimeFormFields,
    ...ongoingFormFields,
});
